export default __webpack_public_path__ + "static/media/two.81232100.jpg";